export default __webpack_public_path__ + "static/media/login-logo.67742cf4.svg";